import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15 3H5c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H5c-.551 0-1-.449-1-1V6h12v10c0 .551-.449 1-1 1zm-7.5-2h-1c-.275 0-.5-.225-.5-.5v-5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v5c0 .275-.225.5-.5.5zm6 0h-1c-.275 0-.5-.225-.5-.5v-3c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v3c0 .275-.225.5-.5.5zm-3 0h-1c-.275 0-.5-.225-.5-.5v-6c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v6c0 .275-.225.5-.5.5z',
  ],
  height: 20,
  width: 20,
});
